import React from 'react';
import {
  motion,
  useMotionValue,
  useSpring,
  AnimatePresence,
} from 'framer-motion';
import { useGesture } from 'react-use-gesture';

const cursorVars = {
  visible: {
    scale: 1,
    opacity: 1,
  },
  dragging: {
    scale: 0.5,
    opacity: 1,
  },
  hidden: {
    scale: 0.2,
    opacity: 0,
  },
};

const cursorTextVars = {
  visible: {
    opacity: 1,
  },
  dragging: {
    opacity: 0,
  },
  hidden: {
    opacity: 0,
  },
};

const CustomCursor = ({ children, className }) => {
  const [cursorActive, setCursorActive] = React.useState(false);
  const [isDrag, setDrag] = React.useState(false);

  const cursorX = useMotionValue(-100);
  const cursorY = useMotionValue(-100);

  const springConfig = { damping: 40, stiffness: 300 };
  const cursorXSpring = useSpring(cursorX, springConfig);
  const cursorYSpring = useSpring(cursorY, springConfig);

  const bind = useGesture({
    onHover: ({ hovering }) => setCursorActive(hovering),
    onDrag: ({ dragging }) => setDrag(dragging),
    onMove: ({ xy: [x, y] }) => {
      cursorX.set(x - 40);
      cursorY.set(y - 40);
    },
  });

  return (
    <div {...bind()}>
      <AnimatePresence>
        {cursorActive && (
          <motion.div
            style={{
              width: '80px',
              height: '80px',
              translateX: cursorXSpring,
              translateY: cursorYSpring,
              backgroundColor: 'var(--green)',
            }}
            className='fixed left-0 top-0 rounded-full z-50 pointer-events-none cursor-none flex items-center justify-center drag-cursor text-white'
            variants={cursorVars}
            initial='hidden'
            animate={isDrag ? 'dragging' : 'visible'}
            exit='hidden'>
            <motion.span variants={cursorTextVars}>&lt; Drag &gt;</motion.span>
          </motion.div>
        )}
      </AnimatePresence>
      <div className={className}>{children}</div>
    </div>
  );
};

export default CustomCursor;
